<!-- 租宝分成 ｜ 售宝分成明细 -->
<template>
  <div class="month-detail-container">
    <div class="header">
      <div class="title">
        {{ currentPoiBillInfo.poiName }}
      </div>
      <div
        v-if="!isTaxEffectedBill"
        class="info"
      >
        <span
          v-if="isSaleType"
          class="info-left"
        >
          售宝数量：{{ currentPoiBillInfo.saleCount }}
        </span>
        <span
          v-else-if="currentPoiBillInfo.isDividedPropVisible"
          class="info-left"
        >
          参与分成：{{ currentPoiBillInfo.rentGtv | formatAmount }}元
        </span>
        <span
          class="info-right"
          @click="showProfit=!showProfit"
        >
          我的分成：{{ currentPoiBillInfo.settleDivided | formatAmount }}元
          <van-icon
            v-if="showStarMode"
            :name="showProfit?'arrow-up':'arrow-down'"
          />
          <div
            v-if="showStarMode&&showProfit"
            class="profit"
          >
            <div>
              基础分成：{{ currentPoiBillInfo.baseDivided | formatAmount }}元
            </div>
            <div v-if="from==='billed'">
              星级奖励分成({{ currentPoiBillInfo.rentRewardRatio/100 }}%)：{{ currentPoiBillInfo.rentRewardAmount | formatAmount }}元
            </div>
            <div v-if="from==='billed'">
              专项奖励分成({{ currentPoiBillInfo.specialRewardRate/100 }}%)：{{ currentPoiBillInfo.specialRewardAmount | formatAmount }}元
            </div>
          </div>
        </span>
      </div>
      <pre-paid-tip
        v-if="currentPoiBillInfo.prepaidBill"
      />
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getData"
    >
      <BillTable
        :data="list"
        :columns="columns"
        @show-tip="onClickShowTip"
      >
        <template #pre>
          <mtd-table-column
            label="日期"
            fixed
            min-width="100px"
          >
            <template #default="{row}">
              <div
                :class="{'like-a':showViewDetail}"
                @click="onClickDate(showViewDetail, row)"
              >
                {{ row.date }}
              </div>
            </template>
          </mtd-table-column>
        </template>
        <mtd-table-column
          v-if="showViewDetail"
          label="操作"
        >
          <template v-slot="scope">
            <mtd-button
              size="small"
              type="text-primary"
              :data-bid="$BID.BILL_MONTH_POI_CHECK"
              :data-cid="cid"
              @click="gotoPage(scope.row)"
            >
              查看
            </mtd-button>
          </template>
        </mtd-table-column>
      </BillTable>
    </van-list>
    <TipModal
      v-model="showTip"
      :title="tip.title"
      :msg="tip.msg"
    />
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import List from 'vant/lib/list';
import TipModal from '@/components/TipModal';
import BillTable from '@/components/BillTable';
import PrePaidTip from '@/views/bill/components/PrePaidTip';
import BillApi from '@/api/bill';
import STATUS from '@/constants/status';
import { BILLTYPE, SHARE_MODE } from '@/constants/bill';
import { formatAmount } from '@/util/filter';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';


export default {
  name: 'MonthBillDetail',
  components: {
    [List.name]: List,
    TipModal,
    BillTable,
    PrePaidTip,
  },
  data() {
    return {
      type: -1, // 0:租宝、1:售宝
      from: '',
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      list: [],
      saleColumns: [
        {
          label: '售宝数量',
          prop: 'saleDayCount',
        },
        {
          label: '我的分成（元）',
          prop: 'myClear',
          width: '130px',
          formatter(row) {
            return formatAmount(row.myClear);
          },
        },
      ],
      showTip: false,
      tip: {},
      showProfit: false,
    };
  },
  computed: {
    ...mapState('billModule', ['customerId', 'currentPoiBillInfo']),
    ...mapGetters('billModule', ['isTaxEffectedBill']),
    ...mapGetters(['isAgentUser']),
    isSaleType() {
      return this.type === BILLTYPE.SALE;
    },
    shareMode() {
      return this.currentPoiBillInfo.shareMode;
    },
    // 租宝、星级分润模式
    showStarMode() {
      return !this.isSaleType && this.shareMode === SHARE_MODE.STAR;
    },
    showViewDetail() {
      return this.currentPoiBillInfo.allowVisitFlow;
    },
    rentColumns() {
      const { isTaxEffectedBill, isAgentUser } = this;
      const { isDividedPropVisible, showRemind } = this.currentPoiBillInfo; // isDividedPropVisible表示是否显示租宝的分成比例与参与分成金额列(当合作商配置了poi账单不可查看，isDividedPropVisible为false)
      const columns = [
        {
          label: '参与分成(元)',
          show: !isTaxEffectedBill && isDividedPropVisible,
          minWidth: '120px',
          // 展示奖励金额，说明当前账单为受到增值税影响的账单，所以也要展示提示
          tip: showRemind ? { title: '参与分成', msg: '参与分成为税后金额，实际金额以账单结算为准。' } : null,
          formatter(row) {
            return formatAmount(row.dividedAmount);
          },
        },
        {
          label: '订单金额(元)',
          show: isTaxEffectedBill && isDividedPropVisible,
          minWidth: '120px',
          // 展示奖励金额，说明当前账单为受到增值税影响的账单，所以也要展示提示
          tip: showRemind ? { title: '订单金额', msg: '订单金额为税前金额，实际到账金额以我的分成为准。' } : null,
          formatter(row) {
            return formatAmount(row.orderAmount);
          },
        },
        {
          label: '分成比例',
          prop: 'dividedRate',
          show: isDividedPropVisible && !isAgentUser,
          minWidth: '100px',
          formatter(row) {
            const rate = Number(row.dividedRate / 100).toFixed(2);
            return `${rate}%`;
          },
        },
        {
          label: this.shareMode === SHARE_MODE.STAR ? '基础分成(元)' : '我的分成(元)',
          prop: 'myClear',
          show: !isTaxEffectedBill || !isDividedPropVisible,
          minWidth: '110px',
          formatter(row) {
            return formatAmount(row.myClear);
          },
        },
      ];
      const arr = columns.filter((item) => item.show);
      return arr;
    },
    columns() {
      let cols = [];
      if (this.type === BILLTYPE.SALE) {
        cols = this.saleColumns;
      } else if (this.type === BILLTYPE.RENT) {
        cols = this.rentColumns;
      }
      return cols;
    },
    cid() {
      return this.$CID.MonthBillDetail;
    },
  },
  mounted() {
    this.type = Number(this.$route.query.type);
    this.from = this.$route.query.from;
    this.getData();
  },
  methods: {
    ...mapMutations('billModule', ['setCurrentDayBillInfo']),
    async getData() {
      const {
        settleUnitId, poiId, cutMonth, billMonth, prepaidBill, agreementId, tagId, settleUnitMode,
      } = this.currentPoiBillInfo;
      const params = {
        customerId: this.customerId,
        shareMode: this.shareMode,
        settleUnitId,
        type: this.type,
        poiId,
        month: cutMonth,
        billMonth,
        prepaidBill,
        agreementId,
        tagId,
        settleUnitMode,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      const res = await BillApi.getMonthBillDetail(params);
      if (res.code === STATUS.SUCCESS && res.data) {
        const { isFinished = true, content } = res.data;
        this.list = this.list.concat(content || []);
        this.finished = isFinished;
        if (!this.finished) {
          this.pageNum += 1;
        }
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    gotoPage(data) {
      this.setCurrentDayBillInfo(data);
      this.$router.push({
        name: 'DailyBillDetail',
      });
    },
    onClickDate(showViewDetail, data) {
      if (showViewDetail) {
        this.gotoPage(data);
        tracker.sendModuleClick(BID.BILL_MONTH_POI_DATE, this.cid);
      }
    },
    onClickShowTip(tip) {
      this.showTip = true;
      this.tip = tip;
      tracker.sendModuleClick(BID.BILL_MONTH_POI_CLEAR_QUESTION, this.cid);
    },
  },
  beforeRouteEnter(to, from, next) {
    document.title = Number(to.query.type) === BILLTYPE.RENT ? '租宝分成明细' : '售宝分成明细';
    next();
  },
};
</script>
<style lang="scss" scoped>
.month-detail-container {
  .header {
    margin: 24px;
    .title {
      font-size: 36px;
      color: rgba(0, 0, 0, 0.84);
      font-weight: bold;
      text-align: left;
    }
    .info {
      display: flex;
      justify-content: space-between;
      text-align: left;
      margin: 12px 0;
      .info-left {
        width: 50%;
      }

      .info-right {
        text-align: right;
      }
    }
    .pre-paid {
      text-align: left;
      color: red;
    }
    .profit {
      margin-top: 12px;
      font-size: 24px;
      color:#999;
    }
  }
  .like-a {
    color: rgb(10, 112, 245);
    text-decoration: underline;
  }
}
</style>
